import React, { useEffect, useState, useRef } from 'react';
import { Modal, Space, Spin, Descriptions, Button } from 'antd';
import { DatePicker } from 'antd';
import { INSURANCE_OPERATORS, INSURANCE_VIEW_BILL, INSURANCE_BILL_PAYMENT } from '../../Utils/appConstants';
import { getRequest, postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'antd/dist/antd.css';
import moment from 'moment';
import Select from 'react-select';

function InsuranceBillPayment(props) {
    const dateFormat = 'DD/MM/YYYY';
    const queryDateFormat = 'YYYY-MM-DD';

    const history = useHistory();
    const operatorSelect = useRef(null);

    const [isModalViewBill, setIsModalViewBill] = useState(false);
    const [getOperatorData, setOperatorData] = useState([]);
    const [getDataField, setDataField] = useState({});
    const [getDataError, setDataError] = useState({});
    const [getCustomerInfo, setCustomerInfo] = useState({});
    const [paymentId, setPaymentId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [operatorDateFormat, setOperatorDateFormat] = useState("");
    const [commissionData, setCommissionData] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);

    const getOperators = () => {
        getRequest(INSURANCE_OPERATORS, history).then((response) => {
            if (response.success === true) {
                const filteredData = response.data.filter(item =>
                    item.ind_code && item.ind_code.toString().trim() !== ''
                );
                const options = filteredData.map((item) => ({
                    value: item.code,
                    label: item.name,
                    ind_code: item.ind_code,
                    dateformat: item.dateFormat,
                }));
                setOperatorData(options);
            } else {
                toast.error(response.message || "Failed to load operators");
            }
        }).catch((error) => {
            console.error("Error fetching operators:", error);
            toast.error("Failed to load insurance providers");
        });
    };

    const onChangeValueSelect = (selectedOption) => {
        if (!selectedOption) return;
        setOperatorDateFormat(selectedOption.dateformat || "");
        setDataField(prev => ({
            ...prev,
            operator: selectedOption.value,
            ind_code: selectedOption.ind_code,
            provider: selectedOption.ind_code
        }));
    };

    const onChangeValue = (e) => {
        const { name, value } = e.target;
        setDataField(prev => ({ ...prev, [name]: value }));
    };

    const onChangeDatePicker = (date) => {
        if (date) {
            const dateValue = moment(date).format(queryDateFormat);
            let operatorFormattedDate = "";
            if (operatorDateFormat) {
                operatorFormattedDate = moment(date).format(operatorDateFormat);
            }
            setDataField(prev => ({
                ...prev,
                dateOfBirth: dateValue,
                operatorDate: operatorFormattedDate
            }));
        }
    };

    const onChangeDueDatePicker = (date) => {
        if (date) {
            const dateValue = moment(date).format(queryDateFormat);
            setDataField(prev => ({ ...prev, dueDate: dateValue }));
        }
    };

    const FormValidate = () => {
        let formObject = {};
        let formValid = true;

        if (!getDataField.operator) {
            formObject.operator = true;
            formValid = false;
        }
        if (!getDataField.policyNumber || !getDataField.policyNumber.trim()) {
            formObject.policyNumber = true;
            formValid = false;
        }
        if (!getDataField.dateOfBirth) {
            formObject.dateOfBirth = true;
            formValid = false;
        }
        if (!getDataField.dueDate) {
            formObject.dueDate = true;
            formValid = false;
        }

        setDataError(formObject);
        return formValid;
    };

    const viewBill = () => {
        if (!FormValidate()) return;

        setLoading(true);

        const payload = {
            provider: getDataField.ind_code,
            policyNumber: getDataField.policyNumber,
            dateOfBirth: getDataField.dateOfBirth,
            dueDateOn: getDataField.dueDate,
            operatorDate: getDataField.operatorDate || "",
            email: getDataField.email || "",
            mobile: getDataField.mobile || ""
        };

        postRequest(INSURANCE_VIEW_BILL, payload, history).then((response) => {
            if (response.success === true) {
                setIsModalViewBill(true);
                setCustomerInfo(response.data);
                setCommissionData(response.commissionData);
                setPaymentId(response.id);
                setDataField(prev => ({ ...prev, amount: response.data?.Netamount }));
            } else {
                toast.error(response.message || "Failed to fetch bill");
            }
            setLoading(false);
        }).catch((error) => {
            console.error(error);
            toast.error("Something went wrong while fetching bill");
            setLoading(false);
        });
    };

    const billPayment = () => {
        if (!getDataField.amount || parseFloat(getDataField.amount) <= 0) {
            toast.error("Invalid bill amount");
            return;
        }

        setPaymentLoading(true);

        const payload = {
            provider: getDataField.ind_code || getDataField.provider,
            paymentId: paymentId,
            amount: getDataField.amount,
            policyNumber: getDataField.policyNumber,
            dob : getDataField.dateOfBirth,
            dueDateOn: getDataField.dueDate,
            operatorDate: getDataField.operatorDate || "",
            emailId: getDataField.email || "",
            mobile: getDataField.mobile || "",
            operator: getDataField.operator,
        };

        postRequest(INSURANCE_BILL_PAYMENT, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                setIsModalViewBill(false);
                setDataField({});
                setCustomerInfo({});
                setCommissionData(null);
                setPaymentId(null);
            } else {
                toast.error(response.message || "Payment failed");
            }
        }).catch((error) => {
            console.error(error);
            toast.error("Something went wrong during payment");
        }).finally(() => {
            setPaymentLoading(false);
        });
    };

    const handleHideModal = () => {
        setIsModalViewBill(false);
    };

    useEffect(() => {
        getOperators();
    }, []);

    return (
        <div>
            {loading && (
                <div className={'parentDisable'} style={{ width: '100%' }}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Spin tip="Loading..." size="large">
                            <div className="spin-loader" />
                        </Spin>
                    </Space>
                </div>
            )}

            <div className='pt-4'>
                <h4 className='mb-3'>Insurance Premium Payment</h4>

                <div className="form-group">
                    <Select
                        options={getOperatorData}
                        className={`normal-light w-100 ${getDataError.operator ? "is-invalid" : ""}`}
                        classNamePrefix="select"
                        placeholder="Select Your Insurance Provider"
                        onChange={onChangeValueSelect}
                        ref={operatorSelect}
                    />
                    {getDataError.operator && <span className="error text-danger">Please select insurance provider</span>}
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className={`form-control normal-light ${getDataError.policyNumber ? "is-invalid" : ""}`}
                        placeholder="Enter Policy Number"
                        name="policyNumber"
                        onChange={onChangeValue}
                    />
                    {getDataError.policyNumber && <span className="error text-danger">Policy number is required</span>}
                </div>

                <div className="form-group">
                    <DatePicker
                        format={dateFormat}
                        className={`form-control normal-light ${getDataError.dateOfBirth ? "is-invalid" : ""}`}
                        placeholder="Select Date Of Birth"
                        onChange={onChangeDatePicker}
                    />
                    {getDataError.dateOfBirth && <span className="error text-danger">Date of birth is required</span>}
                </div>

                <div className="form-group">
                    <DatePicker
                        format={dateFormat}
                        className={`form-control normal-light ${getDataError.dueDate ? "is-invalid" : ""}`}
                        placeholder="Select Due Date"
                        onChange={onChangeDueDatePicker}
                    />
                    {getDataError.dueDate && <span className="error text-danger">Due date is required</span>}
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className="form-control normal-light"
                        placeholder="Customer Mobile (Optional)"
                        name="mobile"
                        onChange={onChangeValue}
                        maxLength={10}
                    />
                </div>

                <div className="form-group">
                    <input
                        type="text"
                        className="form-control normal-light"
                        placeholder="Enter Email Address (Optional)"
                        name="email"
                        onChange={onChangeValue}
                    />
                </div>

                <div className='row pt-2'>
                    <div className='col-12'>
                        <button
                            type="button"
                            className="btn btn-danger mb-2 btn-block"
                            onClick={viewBill}
                            disabled={loading}
                        >
                            View Bill
                        </button>
                    </div>
                </div>
            </div>

            <ToastContainer position="top-center" autoClose={5000} />

            {isModalViewBill && (
                <Modal
                    title="Customer Bill Details"
                    width={540}
                    open={isModalViewBill}
                    onCancel={handleHideModal}
                    centered
                    footer={[
                        <Button
                            key="cancel"
                            size="large"
                            onClick={handleHideModal}
                            style={{ marginRight: '32px', minWidth: '120px' }}
                        >
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            type="primary"
                            size="large"
                            loading={paymentLoading}
                            disabled={!getDataField.amount || parseFloat(getDataField.amount) <= 0}
                            onClick={billPayment}
                            style={{
                                minWidth: '160px',
                                backgroundColor: '#C9262C',
                                borderColor: '#C9262C',
                                color: '#FFDD09'
                            }}
                        >
                            {paymentLoading ? 'Processing...' : `Pay ₹${getDataField.amount || '0'}`}
                        </Button>
                    ]}
                >
                    {paymentLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px 0' }}>
                            <Spin tip="Processing Payment..." size="large" />
                        </div>
                    ) : getCustomerInfo ? (
                        <div style={{ padding: '8px 0' }}>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item label="Customer Name">
                                    <strong>{getCustomerInfo.CustomerName}</strong>
                                </Descriptions.Item>
                                <Descriptions.Item label="Due Date">
                                    {getCustomerInfo.Duedate}
                                </Descriptions.Item>
                                <Descriptions.Item label="Bill Amount">
                                    <span style={{
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#C9262C'
                                    }}>
                                        ₹{getCustomerInfo.Netamount}
                                    </span>
                                </Descriptions.Item>
                            </Descriptions>

                            <div style={{ marginTop: 20 }}>
                                <h5 style={{ marginBottom: 10, color: '#C9262C' }}>Commissions</h5>
                                <Descriptions bordered column={1} size="small">
                                    <Descriptions.Item label="Service Amount">
                                        ₹{Number(commissionData?.serviceAmount || 0).toFixed(2)}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Commission Amount">
                                        ₹{Number(commissionData?.commissionAmount || 0).toFixed(2)}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="TDS Amount">
                                        ₹{Number(commissionData?.tdsAmount || 0).toFixed(2)}
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>

                            <div style={{
                                background: '#FFF9E6',
                                border: '1px solid #FFDD09',
                                borderRadius: '6px',
                                padding: '12px',
                                marginTop: 20,
                                fontSize: '14px'
                            }}>
                                <ul style={{ paddingLeft: '18px', margin: '0' }}>
                                    <li>Payment will be reflect in 12 working hours</li>
                                    <li>Same Day due Date Payment not allowed</li>
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center', padding: '30px 0' }}>No customer information available.</p>
                    )}
                </Modal>
            )}
        </div>
    );
}

export default InsuranceBillPayment;